// extracted by mini-css-extract-plugin
export default {"specialContainer":"MJGNivPg2N247jl7qghS","incoming":"arwrco7OQ4ssNakyXjRA","unsupportedMessageContainer":"C4HAMLiWsufSYWdtvY23","unsupportedMessageType":"NKEh8chiSo8UFpUNPIjC"};